var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("markdown-text", { attrs: { text: _vm.text } }),
      _vm._v(" "),
      _vm.hasReferencedSections
        ? _c("div", { staticClass: "font-weight-bold text-sm mt-3 mb-1" }, [
            _vm._v("Referenced Sections"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-chip-group",
        {
          attrs: { column: "" },
          model: {
            value: _vm.sectionSelected,
            callback: function ($$v) {
              _vm.sectionSelected = $$v
            },
            expression: "sectionSelected",
          },
        },
        _vm._l(_vm.sources, function (chip, index) {
          return _c(
            "v-chip",
            {
              key: index,
              class:
                chip.meta_xmlId === _vm.sectionSelected
                  ? "text--white"
                  : "primary--text",
              attrs: {
                value: chip.meta_xmlId,
                text: _vm.displayChipInfo(chip),
                small: "",
                color:
                  chip.meta_xmlId === _vm.sectionSelected
                    ? "primary"
                    : "primaryLight",
              },
              on: {
                click: function ($event) {
                  return _vm.getSection(chip.meta_xmlId)
                },
              },
            },
            [
              _c("span", {
                staticClass: "ai-reference-section",
                domProps: { innerHTML: _vm._s(_vm.displayChipInfo(chip)) },
              }),
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.loadingReferenceContent
        ? _c(
            "div",
            { staticClass: "text-center pa-2" },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _c("default-content-section-controller", {
            staticClass: "mt-2",
            attrs: {
              highlightType: "add-note",
              registerDialogs: false,
              "content-sections": _vm.contentSections,
              "is-notes-section-expanded": true,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }